import { render, staticRenderFns } from "./ProvisioningStep.vue?vue&type=template&id=0cffaf35&scoped=true&"
import script from "./ProvisioningStep.vue?vue&type=script&lang=js&"
export * from "./ProvisioningStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffaf35",
  null
  
)

export default component.exports